import { useAsync } from 'react-use';

import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

function stripOuAndBu(node: any): any {
  const { team_id, children = [] } = node;
  return {
    team_id,
    children: Array.isArray(children) ? children.map(stripOuAndBu) : [],
  };
}

function isNonEmptyTree(tree: any): boolean {
  return Boolean(tree && Object.keys(tree).length > 0);
}

export const useTeamTree = (teamId: string) => {
  const identityApi = useApi(identityApiRef);
  const discoveryApi = useApi(discoveryApiRef);
  const { value: teamTree } = useAsync(async () => {
    const { token } = await identityApi.getCredentials();
    const endpointBase = await discoveryApi.getBaseUrl('common-utilities');
    const teamIds = teamId
      .split(',')
      .map(id => id.trim())
      .filter(Boolean);

    let data: any = { tree: {} };
    for (const currentTeamId of teamIds) {
      const response = await fetch(
        `${endpointBase}/team-tree/${currentTeamId.toUpperCase()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const candidateData = await response.json();
      data = candidateData;

      if (isNonEmptyTree(candidateData.tree)) {
        break;
      }
    }

    const idsTree = stripOuAndBu(data.tree ?? {});
    return { ...data, tree: idsTree };
  });
  return { teamTree };
};
